var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRightArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3078_24983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3078_24983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.52213 10.8334H15.8346C16.0707 10.8334 16.2687 10.7536 16.4284 10.5938C16.5881 10.4341 16.668 10.2362 16.668 10.0001C16.668 9.76398 16.5881 9.56606 16.4284 9.40634C16.2687 9.24662 16.0707 9.16676 15.8346 9.16676H6.52213L10.6055 5.08342C10.7721 4.91676 10.852 4.72231 10.8451 4.50009C10.8381 4.27787 10.7513 4.08342 10.5846 3.91676C10.418 3.76398 10.2235 3.68412 10.0013 3.67717C9.77908 3.67023 9.58464 3.75009 9.41797 3.91676L3.91797 9.41676C3.83463 9.50009 3.77561 9.59037 3.74088 9.68759C3.70616 9.78481 3.6888 9.88898 3.6888 10.0001C3.6888 10.1112 3.70616 10.2154 3.74088 10.3126C3.77561 10.4098 3.83463 10.5001 3.91797 10.5834L9.41797 16.0834C9.57075 16.2362 9.76172 16.3126 9.99089 16.3126C10.2201 16.3126 10.418 16.2362 10.5846 16.0834C10.7513 15.9168 10.8346 15.7188 10.8346 15.4897C10.8346 15.2605 10.7513 15.0626 10.5846 14.8959L6.52213 10.8334Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRightArrowWhite);
export default __webpack_public_path__ + "static/media/ic_right_arrow_white.b0cbd92750c9a0820b699458eabc7a36.svg";
export { ForwardRef as ReactComponent };